// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2YkGD","dragIcon":"SortableItem_dragIcon__1eBX4","disabled":"SortableItem_disabled__3R79A"};